export default "__VITE_ASSET__c7DGT3wV__"